// extracted by mini-css-extract-plugin
module.exports = {"button":"LinkButton_button__dxu44","btn_normal":"LinkButton_btn_normal__BDuHs","btn_disabled":"LinkButton_btn_disabled__LKzKy","new_badge":"LinkButton_new_badge__d5csV"};